import React from 'react';
import SupplierCreditDetailModal from '../SupplierCredit/SupplierCreditDetailModal';
import { getOrderFundingDisplay } from '../../utils/quoteFundingDisplay';

/**
 * Read-only funding display for an order (credit, budget, or prepayment).
 *
 * @param {{ order: Object, className?: string }} props
 */
const OrderFundingDisplay = ({ order, className = 'fs-6' }) => {
  const funding = getOrderFundingDisplay(order);

  if (funding.type === 'order_credit') {
    return (
      <span className={className}>
        <SupplierCreditDetailModal
          creditObj={
            typeof funding.credit === 'object' ? funding.credit : null
          }
          creditId={funding.creditId}
        />
        {funding.amountCharged != null && funding.amountCharged !== '' && (
          <>
            <br />
            <span className="small">
              Charged from credit: {funding.amountCharged}
              {typeof funding.credit === 'object' && funding.credit?.currency
                ? ` ${funding.credit.currency}`
                : ''}
            </span>
          </>
        )}
      </span>
    );
  }

  if (funding.type === 'quote_credit') {
    return (
      <span className={className}>
        <SupplierCreditDetailModal
          creditObj={
            typeof funding.credit === 'object' ? funding.credit : undefined
          }
          creditId={funding.creditId}
        />
      </span>
    );
  }

  if (funding.type === 'budget') {
    return <span className={className}>{funding.budget}</span>;
  }

  if (funding.type === 'prepayment') {
    return (
      <span className={className}>
        {funding.prepaymentAmount}
        {funding.prepaymentCurrency ? ` ${funding.prepaymentCurrency}` : ''}
      </span>
    );
  }

  return <span className="text-muted">-</span>;
};

export default OrderFundingDisplay;
